module.exports = "<div ng-bind-html=\"match.label | gwTypeaheadHighlight:query\"\r\n     ng-attr-title=\"{{match.label}}\"></div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./common/grunt/webpack/loaders/text-loader!./common/js/src/edge/platform/widgets/typeahead/matchContentDirectives/Default/Default.html
// module id = 608
// module chunks = 0